// Single source of truth for the attribution field names.
// Shared by the pre-consent browser bootstrap, the hidden form fields, the
// submit helper and the server-side ingestion route so no field can be
// silently dropped on the way from the browser to the saved lead.

/** Form + visitor identity fields. */
export const FORM_FIELDS = [
  'attribution_version',
  'visitor_id',
  'session_id',
  'form_id',
  'form_name',
  'form_page_url',
  'form_page_title',
  'form_submitted_at',
] as const

/** Keys inside a touch record (first_touch / last_touch objects). */
export const TOUCH_KEYS = [
  'channel',
  'source',
  'medium',
  'campaign',
  'campaign_id',
  'content',
  'term',
  'source_platform',
  'landing_page',
  'referrer',
  'timestamp',
] as const

export const FIRST_TOUCH_FIELDS = TOUCH_KEYS.map(
  (k) => `first_touch_${k}`
) as string[]
export const LAST_TOUCH_FIELDS = TOUCH_KEYS.map(
  (k) => `last_touch_${k}`
) as string[]

/** Advertising / platform click identifiers, stored verbatim. */
export const CLICK_ID_FIELDS = [
  'gclid',
  'gbraid',
  'wbraid',
  'dclid',
  'msclkid',
  'fbclid',
  'ttclid',
  'li_fat_id',
  'twclid',
  'sccid',
  'epik',
  'rdt_cid',
  'gad_source',
  'gad_campaignid',
  'gclsrc',
] as const

/** Paid-media detail fields (Google Ads ValueTrack and friends). */
export const PAID_DATA_FIELDS = [
  'campaign_name',
  'campaign_id',
  'adgroup_name',
  'adgroup_id',
  'ad_id',
  'creative',
  'keyword',
  'matchtype',
  'network',
  'device',
  'device_model',
  'placement',
  'placement_category',
  'adposition',
  'target_id',
  'asset_group_id',
  'ad_type',
  'loc_physical_ms',
  'loc_interest_ms',
  'extension_id',
  'feed_item_id',
  'video_source_id',
] as const

/** Legacy flat UTM + context fields kept for existing dashboard filters. */
export const LEGACY_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_source_platform',
  'utm_campaign',
  'utm_id',
  'utm_term',
  'utm_content',
  'landing_url',
  'referrer',
] as const

/** Every flat (text) attribution field carried on a lead. */
export const ATTRIBUTION_TEXT_FIELDS: string[] = [
  ...FORM_FIELDS,
  ...FIRST_TOUCH_FIELDS,
  ...LAST_TOUCH_FIELDS,
  ...CLICK_ID_FIELDS,
  ...PAID_DATA_FIELDS,
  ...LEGACY_FIELDS,
]

/** Structured JSON backups stored alongside the flat fields. */
export const ATTRIBUTION_JSON_FIELDS = [
  'first_touch',
  'last_touch',
  'click_ids',
  'paid_data',
  'attribution_json',
] as const

/** Field names rendered as hidden inputs inside every lead form. */
export const HIDDEN_INPUT_FIELDS: string[] = [
  ...ATTRIBUTION_TEXT_FIELDS,
  'attribution_json',
]
